import styled, { css } from 'styled-components';
import getColumnWidth from '../get-column-width';

const ColumnWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: ${({ $flexDirection }) => $flexDirection || 'row'};
  gap: 1rem;

  ${({ $columnWidth, $offset }) => css`
    grid-column: span ${getColumnWidth('full')};
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      grid-column: ${($offset > 0 && $offset < 10) ? `${$offset + 1} /` : ''} span ${getColumnWidth($columnWidth)};
    }
  `}
  ${({ $align }) => css`
    align-items: ${$align};
  `}
  ${({ $justify }) => css`
    justify-content: ${$justify};
  `}
  ${({ $order }) => css`
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      order: ${$order};
    }
  `}
`;

export default ColumnWrapper;
